<template>
    <ValidationProvider 
        ref="provider"
        v-slot="{ classes, errors }" 
        :rules="rules" 
        :custom-messages="customMessages" 
        :name="name" 
        :vid="name" 
        :class="$attrs['class']" 
        class="w-full"
        tag="div">
        <div class="digi-select w-full" :class="classes">
            <label class="form-label font-inter font-bold text-viva-money-black" :for="name" v-html="label"></label>
            <div class="form-input flex-wrap -m-2">
                <div class="p-2">
                    <div class="input-wrapper input-wrapper-select w-full relative flex-shrink-0">
                        <select
                            :value="value"
                            class="h-12 w-full select textbox px-4 py-2 text-base pr-16 focus:outline-none appearance-none font-inter text-viva-money-black"
                            @input="handleInput"
                            @change="handleChange"
                            :class="classes"
                        >
                            <option v-for="(v, k) in options" :key="k" :value="k" :disabled="v.disabled || false" v-text="v.text ? v.text : v"></option>
                        </select>
                        <div class="select-arrow">
                            <svg width="17" height="9" xmlns="http://www.w3.org/2000/svg"><path d="M1 1l7.5 7L16 1" stroke="#555" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="microtext" class="form-microtext" v-html="microtext"></div>
        </div>
    </ValidationProvider>
</template>
 
<script>
export default {
    props: {
        rules: {
            default: () => {
                return {};
            }
        },
        customMessages: {
            default: () => {
                return {};
            }
        },
        show: {
            default: true
        },
        value: {
            default: ""
        },
        name: {
            default: ""
        },
        label: String,
        options: {
            default: () => {
                return {};
            },
            type: Object
        },
        valid: {
            default: null
        },
        microtext: {
            default: null
        }
    },
    created() {
        if (this.value) {
            this.$nextTick(() => {
                if (this.value) {
                    this.$refs.provider.validate(this.value);
                } else {
                    this.$refs.provider.reset();
                }
            });
        }
    },
    methods: {
        handleInput(e) {
            this.$emit("input", e.target.value);
        },
        handleChange(e) {
            this.$emit("change", e.target.value);
            window.amplitude.dropDownEvent(this.name);
        }
    }
};
</script>

<style lang="scss">
.digi-select.valid {
    .textbox {
        box-shadow: inset 0 0 0 1px #F0BA46;
        @apply border-viva-money-secondary-yellow;
        border-width: 1px;
    }
}

.digi-select.invalid {
    .textbox {
        box-shadow: inset 0 0 0 1px #FF6B6C;
        border-color: #FF6B6C;
        border-width: 1px;
    }
}

.select-arrow {
    position: absolute;
    display: flex;
    width: 50px;
    right: 0;
    top: 1px;
    bottom: 1px;
    justify-content: center;
    align-items: center;
    pointer-events: none;
    & > svg {
        transition: transform .4s cubic-bezier(0.075, 0.82, 0.165, 1);
    }
}

.valid, .invalid  {
    .select-arrow {
        top: 2px;
        bottom: 2px;
    }
}

.select:focus ~ .select-arrow > svg {
    transform: rotateX(180deg);
}
</style>